import PropTypes from 'prop-types';
import { Icon } from '@bwoty-web/ui-kit';
import { useContext } from 'react';
import { TRAVEL_AIRPLANE_UP_RIGHT } from '@bwoty-web/ui-kit/icons';

import GlobalContext from '../../context/globalContext';
import { getCloudinaryTemplateUrl } from '../../utils/imageUtils';

import './cruisePackageInfoFlight.scss';

const CruisePackageInfoFlight = ({ flight, index }) => {
  const { labels } = useContext(GlobalContext);

  const carrierImageUrl = getCloudinaryTemplateUrl(flight.carrierCloudinaryImage, 100, 120);

  return (
    <div className="iw-cruise-package-flight-info_container">
      <p className="iw-cruise-package-flight-info_heading">{`${
        index === 0 ? labels.outbound : labels.homebound
      } ${flight.departureDate}`}</p>
      <div
        key={flight.bookingEngineKey}
        className="iw-cruise-package-flight-info_subContainer"
      >
        <div className="iw-cruise-package-flight-info__image-container">
          {carrierImageUrl ? (
            <img
              className="iw-cruise-package-flight-info__image"
              alt={flight.carrierName}
              src={carrierImageUrl}
            />
          ) : (
            <Icon path={TRAVEL_AIRPLANE_UP_RIGHT} />
          )}
        </div>
        <div className="iw-cruise-package-flight-info__content">
          <p className="iw-cruise-package-flight-info__content-location">
            {`${flight.departureLocation} - ${flight.destinationAirportName}`}
          </p>
          <p className="iw-cruise-package-flight-info__content-datetime">
            {`${flight.departureTime} - ${flight.arrivalTime} `}
          </p>
        </div>
      </div>
    </div>
  );
};

CruisePackageInfoFlight.propTypes = {
  flight: PropTypes.shape({
    arrivalTime: PropTypes.string,
    bookingEngineKey: PropTypes.string,
    carrierCloudinaryImage: PropTypes.shape({
      cloudinaryUriTemplate: PropTypes.string,
      size: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
      }),
    }),
    carrierName: PropTypes.string,
    departureDate: PropTypes.string,
    departureLocation: PropTypes.string,
    departureTime: PropTypes.string,
    destinationAirportName: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
};

export default CruisePackageInfoFlight;
